import type { Template } from "@/types";

export const PO_07_H2_V5: Template[] = [
    {
        id: "po-07-h2v5-01",
        name: "PO 01 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 51, y: 254, width: 306, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 463, width: 306, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 365, y: 254, width: 271, height: 409, rotation: 0, imageRotation: 0 },
            { id: "4", x: 795, y: 114, width: 232, height: 341, rotation: 0, imageRotation: 0 },
            { id: "5", x: 795, y: 463, width: 232, height: 340, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 114, width: 232, height: 341, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 463, width: 232, height: 340, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-02",
        name: "PO 02 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 51, y: 254, width: 306, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 51, y: 463, width: 306, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 365, y: 254, width: 271, height: 409, rotation: 0, imageRotation: 0 },
            { id: "4", x: 744, y: 172, width: 431, height: 573, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1183, y: 171, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1183, y: 365, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1183, y: 559, width: 130, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-03",
        name: "PO 03 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 74, y: 172, width: 569, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 481, width: 386, height: 264, rotation: 0, imageRotation: 0 },
            { id: "3", x: 468, y: 481, width: 175, height: 264, rotation: 0, imageRotation: 0 },
            { id: "4", x: 744, y: 172, width: 431, height: 573, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1183, y: 171, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1183, y: 365, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1183, y: 559, width: 130, height: 185, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-04",
        name: "PO 04 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 74, y: 172, width: 436, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 463, width: 436, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 518, y: 172, width: 125, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 518, y: 366, width: 125, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 518, y: 560, width: 125, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 746, y: 242, width: 281, height: 433, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 242, width: 280, height: 433, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h2v5-05",
        name: "PO 05 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 61, y: 240, width: 291, height: 438, rotation: 0, imageRotation: 0 },
            { id: "2", x: 360, y: 240, width: 269, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 360, y: 463, width: 269, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 744, y: 172, width: 431, height: 573, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1183, y: 172, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1183, y: 366, width: 130, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1183, y: 560, width: 130, height: 185, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h2v5-06",
        name: "PO 06 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 99, y: 179, width: 178, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 99, y: 463, width: 178, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 285, y: 179, width: 177, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 285, y: 463, width: 177, height: 275, rotation: 0, imageRotation: 0 },
            { id: "5", x: 470, y: 179, width: 377, height: 559, rotation: 0, imageRotation: 0 },
            { id: "6", x: 855, y: 179, width: 420, height: 276, rotation: 0, imageRotation: 0 },
            { id: "7", x: 855, y: 463, width: 420, height: 275, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h2v5-07",
        name: "PO 07 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 99, y: 179, width: 178, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 285, y: 179, width: 177, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 470, y: 179, width: 420, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 99, y: 463, width: 420, height: 275, rotation: 0, imageRotation: 0 },
            { id: "5", x: 527, y: 463, width: 178, height: 275, rotation: 0, imageRotation: 0 },
            { id: "6", x: 713, y: 463, width: 177, height: 275, rotation: 0, imageRotation: 0 },
            { id: "7", x: 898, y: 179, width: 377, height: 559, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h2v5-08",
        name: "PO 08 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 296, width: 211, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 219, y: 296, width: 210, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 437, y: 296, width: 500, height: 324, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 296, width: 211, height: 324, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1164, y: 296, width: 210, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1164, y: 462, width: 101, height: 158, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1273, y: 462, width: 101, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h2v5-09",
        name: "PO 09 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 99, y: 179, width: 178, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 99, y: 463, width: 178, height: 275, rotation: 0, imageRotation: 0 },
            { id: "3", x: 285, y: 179, width: 177, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 285, y: 463, width: 177, height: 275, rotation: 0, imageRotation: 0 },
            { id: "5", x: 470, y: 179, width: 420, height: 276, rotation: 0, imageRotation: 0 },
            { id: "6", x: 470, y: 463, width: 420, height: 275, rotation: 0, imageRotation: 0 },
            { id: "7", x: 898, y: 179, width: 377, height: 559, rotation: 0, imageRotation: 0 },
          ],
        },

    {
        id: "po-07-h2v5-10",
        name: "PO 10 - H2V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h2_v5_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 86, y: 0, width: 681, height: 454, rotation: 0, imageRotation: 0 },
            { id: "2", x: 86, y: 462, width: 681, height: 454, rotation: 0, imageRotation: 0 },
            { id: "3", x: 775, y: 0, width: 209, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 775, y: 308, width: 209, height: 300, rotation: 0, imageRotation: 0 },
            { id: "5", x: 775, y: 616, width: 209, height: 300, rotation: 0, imageRotation: 0 },
            { id: "6", x: 992, y: 0, width: 296, height: 455, rotation: 0, imageRotation: 0 },
            { id: "7", x: 992, y: 463, width: 296, height: 454, rotation: 0, imageRotation: 0 },
        ],
    },

];
